/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 2 hook(s) need dependency review; fix each and remove this directive */
import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import folderImg from "../../assets/icons/svg/folder.svg";
import folderLockImg from "../../assets/icons/svg/folderlock.svg";
import spaceImg from "../../assets/icons/svg/spaces.svg";

interface UseFileManagerLeftSideTreeProps {
  setSelectedFolder: Function;
  selectedFolder: any;
  fileManagerData: any;
  onFileLoad: Function;
}

function useFileManagerLeftSideTree({
  setSelectedFolder,
  selectedFolder,
  fileManagerData,
  onFileLoad,
}: UseFileManagerLeftSideTreeProps) {
  // State
  const [folderTreeData, setFolderTreeData] = useState<any>([]);
  const [folderCollapsedState, setFolderCollapsedState] = useState<any>({});
  const [isFileClicked, setIsFileClicked] = useState<boolean>(false);

  // Refs
  const tempRef = useRef<any>(null);

  // Helper functions
  function sortWithHierarchy(arr: any) {
    const byParent = arr.reduce((acc: any, item: any) => {
      if (!acc[item.parentId]) {
        acc[item.parentId] = [];
      }
      acc[item.parentId].push(item);
      return acc;
    }, {});

    function sortRecursive(parentId: any): any[] {
      const children = byParent[parentId] || [];
      children.sort((a: any, b: any) => a.name.localeCompare(b.name));
      return children.flatMap((child: any) => [child, ...sortRecursive(child.id)]);
    }

    return sortRecursive("0");
  }

  // Handlers
  const handleOnClick = (args: any, treeViewRef: any) => {
    setIsFileClicked(true);
    const rowIndex = args.detail.args.row;
    const clickedRow = treeViewRef.current.slickGrid.getDataItem(rowIndex);
    setFolderCollapsedState((prev: any) => {
      prev[clickedRow.id] = !prev[clickedRow.id];
      return prev;
    });
    setSelectedFolder(clickedRow);
  };

  const titleFormatter = (data: any, value: any, a: any, b: any, args: any) => {
    let iconSrc = folderImg;
    if (!args?.permission?.read) {
      iconSrc = folderLockImg;
    }
    if (args.id == "0") {
      iconSrc = spaceImg;
    }
    return `<span style="display:flex;align-items:center;gap:0.375rem; ">
      <img src="${iconSrc}" alt="icon" style="width:1.25rem;height:1.25rem;" />
      ${args.name}
    </span>
  `;
  };

  const collapseParentNodesWithoutChildData = (treeViewRef: any) => {
    setTimeout(() => {
      treeViewRef.current?.treeDataService.toggleTreeDataCollapse(false);
    }, 0);
  };

  const syncSelectedFolder = (treeViewRef: any) => {
    if (treeViewRef.current?.dataView) {
      const dataView = treeViewRef.current?.dataView;
      const rowIndex = dataView.getRowById(selectedFolder.id);
      treeViewRef.current.slickGrid.setSelectedRows([rowIndex]);

      if (selectedFolder.isBulkFetch) {
        const index = folderTreeData.findIndex((d: any) => d.id == selectedFolder.id);
        const node = treeViewRef.current.slickGrid.getCellNode(index, 0);
        const rowNode = node?.closest(".slick-row");
        if (rowNode) {
          rowNode.scrollIntoView({ behavior: "auto", block: "center" });
        }
      }
    }
  };

  // Effects
  useEffect(() => {
    const allItems =
      _.cloneDeep(fileManagerData.files)?.filter(
        (item: any) =>
          ["RESOURCE_TYPE_TRANSMITTAL", "RESOURCE_TYPE_FOLDER"].includes(item.resourceType) && item.id != "0",
      ) || [];

    onFileLoad(allItems);

    const root: any = {
      ...fileManagerData.cwd,
      nodeId: fileManagerData.cwd?.id || "cwd",
      id: "0",
      indentLevel: 0,
      parentId: null,
      treeLevel: 0,
      hasChild: true,
      __hasChildren: true,
      __collapsed: false,
      isExpanded: true,
    };

    let updatedData: any = sortWithHierarchy(allItems);
    updatedData = updatedData.map((d: any) => {
      const level = d.path?.length ?? 0;
      return {
        ...d,
        indentLevel: level === 1 ? 2 : level + 1,
        hasChild: !!d.hasChild,
        __hasChildren: !!d.hasChild,
        treeLevel: level + 1,
        __collapsed: folderCollapsedState[d.id],
        isExpanded: !folderCollapsedState[d.id],
      };
    });

    setFolderTreeData([root, ...updatedData]);
  }, [folderCollapsedState]);

  useEffect(() => {
    const allItems =
      fileManagerData.files?.filter(
        (item: any) =>
          ["RESOURCE_TYPE_TRANSMITTAL", "RESOURCE_TYPE_FOLDER"].includes(item.resourceType) && item.id != "0",
      ) || [];

    setFolderCollapsedState((prev: any) => {
      const newObj = { ...prev };
      allItems.map((f: any) => {
        const childItem = allItems.find((item: any) => item.parentId == f.id);
        if (typeof newObj[f.id] == "undefined" || !isFileClicked) {
          newObj[f.id] = !childItem;
        }
      });
      return newObj;
    });
    setIsFileClicked(false);
  }, [fileManagerData.files]);

  return {
    // State
    folderTreeData,
    setFolderTreeData,
    folderCollapsedState,
    setFolderCollapsedState,

    // Refs
    tempRef,

    // Handlers
    sortWithHierarchy,
    handleOnClick,
    titleFormatter,
    collapseParentNodesWithoutChildData,
    syncSelectedFolder,

    // Props passthrough
    selectedFolder,
  };
}

export default useFileManagerLeftSideTree;
